import { flexRow } from '@anm/styles/helpers';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  margin: 0 63px 50px;
  padding: 5px 5px 33px;
  flex-direction: column;
  text-overflow: ellipsis;
  border-bottom: 1px solid #ccdde6;
`;

export const Title = styled.h2`
  ${flexRow};
  margin: 0;
  flex-shrink: 1;
  max-width: 100%;
  font-size: 16px;
  overflow: hidden;
  font-style: normal;
  font-weight: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default Wrapper;
